<template>
  <div class="home-container">
    <app-navbar8 logoSrc="/logo_trans-1500h.png">
      <template v-slot:link1>
        <div class="home-fragment10"><span class="home-text10">#home</span></div>
      </template>
      <template v-slot:link2>
        <div class="home-fragment11">
          <span class="home-text11">#products</span>
        </div>
      </template>
      <template v-slot:link3>
        <div class="home-fragment12">
          <span class="home-text12">#services</span>
        </div>
      </template>
      <template v-slot:link4>
        <div class="home-fragment13">
          <span class="home-text13">#contact</span>
        </div>
      </template>
      <template v-slot:page1>
        <div class="home-fragment14"><span class="home-text14">Home</span></div>
      </template>
      <template v-slot:page2>
        <div class="home-fragment15">
          <span class="home-text15">Products</span>
        </div>
      </template>
      <template v-slot:page3>
        <div class="home-fragment16">
          <span class="home-text16">Services</span>
        </div>
      </template>
      <template v-slot:page4>
        <div class="home-fragment17">
          <span class="home-text17">Contact</span>
        </div>
      </template>
      <template v-slot:action1>
        <div class="home-fragment18">
          <span class="home-text18">Sign In</span>
        </div>
      </template>
      <template v-slot:action2>
        <div class="home-fragment19"><span class="home-text19">Create</span></div>
      </template>
      <template v-slot:page1Description>
        <div class="home-fragment20">
          <span class="home-text20">Page One Description</span>
        </div>
      </template>
      <template v-slot:page2Description>
        <div class="home-fragment21">
          <span class="home-text21">Page Two Description</span>
        </div>
      </template>
      <template v-slot:page3Description>
        <div class="home-fragment22">
          <span class="home-text22">Page Three Description</span>
        </div>
      </template>
      <template v-slot:page4Description>
        <div class="home-fragment23">
          <span class="home-text23">Page Four Description</span>
        </div>
      </template>
    </app-navbar8>
    <app-hero17>
      <template v-slot:action1>
        <div class="home-fragment24">
          <span class="home-text24">Shop Now</span>
        </div>
      </template>
      <template v-slot:action2>
        <div class="home-fragment25">
          <span class="home-text25">Book Consultation</span>
        </div>
      </template>
      <template v-slot:content1>
        <div class="home-fragment26">
          <span class="home-text26">
            Discover the power of nature with our all natural products and expert
            herbalist services. Let us guide you on your journey to wellness and
            vitality.
          </span>
        </div>
      </template>
      <template v-slot:heading1>
        <div class="home-fragment27">
          <span class="home-text27">Welcome to Wildwood Herbs</span>
        </div>
      </template>
    </app-hero17>
    <app-features24>
      <template v-slot:feature1Title>
        <div class="home-fragment28">
          <span class="home-text28">Herbal Soaps</span>
        </div>
      </template>
      <template v-slot:feature2Title>
        <div class="home-fragment29">
          <span class="home-text29">Herbal Teas</span>
        </div>
      </template>
      <template v-slot:feature3Title>
        <div class="home-fragment30">
          <span class="home-text30">Body Butter</span>
        </div>
      </template>
      <template v-slot:feature1Description>
        <div class="home-fragment31">
          <span class="home-text31">
            Luxurious herbal soaps for a rejuvenating bath experience
          </span>
        </div>
      </template>
      <template v-slot:feature2Description>
        <div class="home-fragment32">
          <span class="home-text32">
            Refreshing herbal teas made from locally sourced herbs
          </span>
        </div>
      </template>
      <template v-slot:feature3Description>
        <div class="home-fragment33">
          <span class="home-text33">
            Handcrafted herbal body butter made with all natural ingredients
          </span>
        </div>
      </template>
    </app-features24>
    <app-cta26>
      <template v-slot:action1>
        <div class="home-fragment34">
          <span class="home-text34">Shop Now</span>
        </div>
      </template>
      <template v-slot:content1>
        <div class="home-fragment35">
          <span class="home-text35">
            Discover our all natural products and herbalist services to enhance
            your well-being.
          </span>
        </div>
      </template>
      <template v-slot:heading1>
        <div class="home-fragment36">
          <span class="home-text36">
            Explore the Power of Nature with Wildwood Herbs
          </span>
        </div>
      </template>
    </app-cta26>
    <home-services rootClassName="home-servicesroot-class-name">
      <template v-slot:feature1Title>
        <div class="home-fragment37">
          <span class="home-text37">Herbalist Services</span>
        </div>
      </template>
      <template v-slot:feature2Title>
        <div class="home-fragment38">
          <span class="home-text38">Gardening Services</span>
        </div>
      </template>
      <template v-slot:feature1Description>
        <div class="home-fragment39">
          <span class="home-text39">
            Stephanie Davis, a Certified Western and Integrative Herbalist,
            provides expert herbalist consultations and services to help you
            achieve your wellness goals.
          </span>
        </div>
      </template>
      <template v-slot:feature2Description>
        <div class="home-fragment40">
          <span class="home-text40">
            Stephanie Davis, a Certified Western and Integrative Herbalist,
            provides expert herbalist consultations and services to help you
            achieve your wellness goals.
          </span>
        </div>
      </template>
    </home-services>
    <app-footer4>
      <template v-slot:termsLink>
        <div class="home-fragment41">
          <span class="home-text41">Terms of Service</span>
        </div>
      </template>
      <template v-slot:cookiesLink>
        <div class="home-fragment42">
          <span class="home-text42">Cookies Settings</span>
        </div>
      </template>
      <template v-slot:privacyLink>
        <div class="home-fragment43">
          <span class="home-text43">Privacy Policy</span>
        </div>
      </template>
    </app-footer4>
  </div>
</template>

<script>
import AppNavbar8 from '../components/navbar8'
import AppHero17 from '../components/hero17'
import AppFeatures24 from '../components/features24'
import AppCta26 from '../components/cta26'
import HomeServices from '../components/home-services'
import AppFooter4 from '../components/footer4'

export default {
  name: 'Home',
  props: {},
  components: {
    AppNavbar8,
    AppHero17,
    AppFeatures24,
    AppCta26,
    HomeServices,
    AppFooter4,
  },
  metaInfo: {
    title: 'Wildwood Herbs',
    meta: [
      {
        property: 'og:title',
        content: 'Wildwood Herbs',
      },
    ],
  },
}
</script>

<style scoped>
.home-container {
  width: 100%;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
 
.home-fragment10 {
  display: contents;
}
 
.home-text10 {
  display: inline-block;
}
 
.home-fragment11 {
  display: contents;
}
 
.home-text11 {
  display: inline-block;
}
 
.home-fragment12 {
  display: contents;
}
 
.home-text12 {
  display: inline-block;
}
 
.home-fragment13 {
  display: contents;
}
 
.home-text13 {
  display: inline-block;
}
 
.home-fragment14 {
  display: contents;
}
 
.home-text14 {
  display: inline-block;
}
 
.home-fragment15 {
  display: contents;
}
 
.home-text15 {
  display: inline-block;
}
 
.home-fragment16 {
  display: contents;
}
 
.home-text16 {
  display: inline-block;
}
 
.home-fragment17 {
  display: contents;
}
 
.home-text17 {
  display: inline-block;
}
 
.home-fragment18 {
  display: contents;
}
 
.home-text18 {
  display: inline-block;
}
 
.home-fragment19 {
  display: contents;
}
 
.home-text19 {
  display: inline-block;
}
 
.home-fragment20 {
  display: contents;
}
 
.home-text20 {
  display: inline-block;
}
 
.home-fragment21 {
  display: contents;
}
 
.home-text21 {
  display: inline-block;
}
 
.home-fragment22 {
  display: contents;
}
 
.home-text22 {
  display: inline-block;
}
 
.home-fragment23 {
  display: contents;
}
 
.home-text23 {
  display: inline-block;
}
 
.home-fragment24 {
  display: contents;
}
 
.home-text24 {
  display: inline-block;
}
 
.home-fragment25 {
  display: contents;
}
 
.home-text25 {
  display: inline-block;
}
 
.home-fragment26 {
  display: contents;
}
 
.home-text26 {
  display: inline-block;
}
 
.home-fragment27 {
  display: contents;
}
 
.home-text27 {
  display: inline-block;
  font-family: "Eagle Lake";
}
 
.home-fragment28 {
  display: contents;
}
 
.home-text28 {
  display: inline-block;
}
 
.home-fragment29 {
  display: contents;
}
 
.home-text29 {
  display: inline-block;
}
 
.home-fragment30 {
  display: contents;
}
 
.home-text30 {
  display: inline-block;
}
 
.home-fragment31 {
  display: contents;
}
 
.home-text31 {
  display: inline-block;
}
 
.home-fragment32 {
  display: contents;
}
 
.home-text32 {
  display: inline-block;
}
 
.home-fragment33 {
  display: contents;
}
 
.home-text33 {
  display: inline-block;
}
 
.home-fragment34 {
  display: contents;
}
 
.home-text34 {
  display: inline-block;
}
 
.home-fragment35 {
  display: contents;
}
 
.home-text35 {
  display: inline-block;
}
 
.home-fragment36 {
  display: contents;
}
 
.home-text36 {
  display: inline-block;
}
 
.home-fragment37 {
  display: contents;
}
 
.home-text37 {
  display: inline-block;
}
 
.home-fragment38 {
  display: contents;
}
 
.home-text38 {
  display: inline-block;
}
 
.home-fragment39 {
  display: contents;
}
 
.home-text39 {
  display: inline-block;
}
 
.home-fragment40 {
  display: contents;
}
 
.home-text40 {
  display: inline-block;
}
 
.home-fragment41 {
  display: contents;
}
 
.home-text41 {
  display: inline-block;
}
 
.home-fragment42 {
  display: contents;
}
 
.home-text42 {
  display: inline-block;
}
 
.home-fragment43 {
  display: contents;
}
 
.home-text43 {
  display: inline-block;
}
</style>
